import React from 'react';
import type { LegacyI18nModel } from './types';

const createLegacyI18nContext = React.createContext as () => React.Context<LegacyI18nModel | undefined>;

export const LegacyI18nContext = createLegacyI18nContext();
